import React, { useState, useEffect } from "react";
import { formatNumber } from "utils/currencyFormat";
import { convertToNumber } from "utils/numberExtension";
import "react-dropdown/style.css";
import BaoCaoTongQuanApi from "../../../service/TongChiNhanh/BaoCaoTongQuanApi";
import ReactDOM from "react-dom";

import C3Chart from 'react-c3js';
import 'c3/c3.css';

export const BieuDoLoiNhuan = ({ }) => {
    const [listYear, setListYear] = useState([]);
    const [selectYear, setSelectYear] = useState(new Date().getFullYear());

    const [chartDataLoiNhuan, setChartDataLoiNhuan] = useState({
        x: 'x',
        columns: []
    });


    const updateSelectYear = () => (e) => {
        setSelectYear(e.target.value)
        LoadCuaHang(e.target.value);
    };



    useEffect(() => {

        const currYear = new Date().getFullYear();
        let aNam = [];
        for (var i = currYear; i >= 2015; i--) {
            const option = {
                label: i,
                value: i,
            }
            aNam.push(option);
        }
        setListYear(aNam);
        LoadCuaHang(currYear);
    }, []);


    const [totalMoney, SetTotalMoney] = useState(0);
    const [loadcomplate, setLoadComplate] = useState(true);
    let totalCom = 0;
    const LoadCuaHang = (year) => {
        setLoadComplate(false);
        setSelectCuaHang('...');
        SetTotalMoney(0);
        chartDataLoiNhuan.columns = [];
        let colThang = ['x', 'Tháng 1', 'Tháng 2', 'Tháng 3', 'Tháng 4', 'Tháng 5', 'Tháng 6', 'Tháng 7', 'Tháng 8', 'Tháng 9', 'Tháng 10', 'Tháng 11', 'Tháng 12'];
        chartDataLoiNhuan.columns.push(colThang);
        BaoCaoTongQuanApi.DanhSachCuaHang().then((response) => {
            totalCom = response.data.length;
            response.data.map((item, index) => (
                setTimeout(function () {
                    LoadBieuDoLoiNhuan(year, item)
                }, 1500)
            ));
        });

    }


    const [selectCuaHang, setSelectCuaHang] = useState('...');
    let loinhuan = 0;
    let count = 0;
    const LoadBieuDoLoiNhuan = (year, itemCom) => {
        let colCuaHang = [];
        BaoCaoTongQuanApi.BieuDoLoiNhuanTheoCuaHang(year, itemCom.MaCuaHang).then((response) => {
            setSelectCuaHang(response.data.TenCuaHang);
            loinhuan = loinhuan + parseFloat(response.data.TongLoiNhuan);

            colCuaHang = [];
            colCuaHang.push(response.data.TenCuaHang);
            response.data.DataLoiNhuan.map((loinhuan, index1) => (
                colCuaHang.push(loinhuan.LoiNhuan)
            ));
            chartDataLoiNhuan.columns.push(colCuaHang);
            setChartDataLoiNhuan(chartDataLoiNhuan);
            SetTotalMoney(loinhuan);
            const rootElement = document.getElementById("bieudoloinhuan")
            ReactDOM.render(<App />, rootElement)
            count = count + 1;
            if (count == totalCom) {
                setLoadComplate(true);
            }
        });
    }
    const BieuDoLoiNhuan = (year) => {

        BaoCaoTongQuanApi.BieuDoLoiNhuan(year).then((response) => {

            chartDataLoiNhuan.columns = [];
            let colThang = ['x', 'Tháng 1', 'Tháng 2', 'Tháng 3', 'Tháng 4', 'Tháng 5', 'Tháng 6', 'Tháng 7', 'Tháng 8', 'Tháng 9', 'Tháng 10', 'Tháng 11', 'Tháng 12'];
            chartDataLoiNhuan.columns.push(colThang);
            let colCuaHang = [];
            if (response.data && response.data.length > 0) {
                let dataLoiNhuan = [];
                response.data.map((item, index) => (
                    colCuaHang = [],
                    colCuaHang.push(item.TenCuaHang),
                    item.DataLoiNhuan.map((loinhuan, index1) => (
                        colCuaHang.push(loinhuan.LoiNhuan)
                    )),
                    chartDataLoiNhuan.columns.push(colCuaHang)
                    //dataLoiNhuan.push(colCuaHang)
                ))
                setChartDataLoiNhuan(chartDataLoiNhuan);
                const rootElement = document.getElementById("bieudoloinhuan")
                ReactDOM.render(<App />, rootElement)
            }
        });
    }


    // const LoadBaoCaoLoiNhuan = () => {
    //     BieuDoLoiNhuan();
    //     // const mountNode = document.getElementById('react-c3js');
    //     // findDOMNode.render(<C3Chart data={chartDataLoiNhuan} />, mountNode);
    // }

    const App = () => {
        return (
            <div className="App">
                <C3Chart
                    data={chartDataLoiNhuan}
                    axis={{
                        x: {
                            type: "category",
                        },
                        y: {
                            tick: {
                                format: function (d) { return formatNumber(d); }
                            }
                        },
                    }}
                    size={{
                        height: 320,
                    }}
                    color={{
                        pattern: ['#B2001F', '#367517',
                            '#A2007C', '#5D0C7B',
                            '#008489', '#67BF7F',
                            '#007F54', '#F1AF00',
                            '#9C9900', '#489620',
                            '#976D00', '#8F006D',
                            '#511F90', '#E33539',
                            '#AF4A92', '#211551',
                            '#00B2BF', '#5BBD2B',
                            '#FCF54C', '#F9F400']
                    }}
                    tooltip={{
                        format: {
                            value: function (value, ratio, id) {
                                return formatNumber(value);
                            }
                        }
                    }}
                />
            </div>
        );
    };

    return (
        <>

            <div className="row" style={{ marginTop: "5px", marginBottom: "10px" }}>
                <div className="col-md-12">
                    <div className="row" style={{ paddingRight: "15px", paddingLeft: "15px" }} >
                        <div className="col-md-12" >
                            <div className="divbaocaochinhanh-cuahang">
                                <div className="row ">
                                    <div className="col-md-12">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div style={{ padding: "15px 15px 0px 15px", color: "#006266", fontWeight: "bold" }}>
                                                    Lợi nhuận năm {selectYear}
                                                    <br />
                                                    <span style={{ color: "#c0392b", fontSize: "18px", fontWeight: "bold" }}>
                                                        {formatNumber(totalMoney)} vnđ
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div style={{ padding: "15px 15px 0px 15px", width: "130px", float: "right" }}>
                                                    {loadcomplate === true ? (<>
                                                        <select
                                                            name="LoiNhuanSearchNam"
                                                            className="selectBox form-control input-sm"
                                                            value={selectYear}
                                                            onChange={updateSelectYear()}
                                                            style={{ paddingLeft: "28px", backgroundColor: "#2D3748", color: "#FFF", borderRadius: "10px" }}
                                                        >
                                                            {listYear &&
                                                                listYear.map((item, idx) => (
                                                                    <option key={"objComboYear" + idx} value={item.value}>
                                                                        {item.label}
                                                                    </option>
                                                                ))}
                                                        </select>
                                                    </>) : (
                                                        <>
                                                            <select
                                                                name="LoiNhuanSearchNam"
                                                                className="selectBox form-control input-sm"
                                                                value={selectYear}
                                                                style={{ paddingLeft: "28px", backgroundColor: "#2D3748", color: "#FFF", borderRadius: "10px" }}
                                                                disabled={true}
                                                            >
                                                                {listYear &&
                                                                    listYear.map((item, idx) => (
                                                                        <option key={"objComboYear" + idx} value={item.value}>
                                                                            {item.label}
                                                                        </option>
                                                                    ))}
                                                            </select>
                                                        </>)}

                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <div className="col-md-12" style={{ minHeight: "320px" }}>
                                        <div id="bieudoloinhuan"></div>
                                    </div>
                                    {loadcomplate === false && (
                                        <>
                                            <div className="warting1">
                                                <div style={{ textAlign: "center", minWidth: "200px" }}>
                                                    Đang tải dữ liệu lợi nhuận năm {selectYear}
                                                    <br />
                                                    Đã thống kê cửa hàng: {selectCuaHang}
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
};
